module.exports = __webpack_public_path__ + "static/media/belasting-4.f24f2402.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-4.svg
// module id = 119
// module chunks = 0